import React from "react";
import { useSelector } from "../../store/store";
import { getDashFormattedDateStringFromISOString } from "../../util/date-util";

export function EndDate() {
  const endDate = useSelector((state) => state.dates.endDate);

  return <>{getDashFormattedDateStringFromISOString(endDate!)}</>;
}
